import PerformingAssetsCard from "../components/PerformingAssetsCard";
import { META } from "../../../../../utils/constants";
import {
  FEMALES,
  GENDERS_PLACEHOLDER,
  MALES,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import { DemographicInsightsGrid } from "./MetaDemographicInsightsTables";

const getGenderRowLabel = ({ gender, t }) => {
  if (gender === "female") return t(FEMALES);
  if (gender === "male") return t(MALES);
  return gender ?? "—";
};

const MetaGenderDemographicInsightsCard = ({
  genderRows = [],
  getCostByMainCurrency,
  sx = {},
}) => {
  const { t } = useTranslationApp();

  if (!genderRows?.length) return null;

  return (
    <PerformingAssetsCard
      platform={META}
      title={t(GENDERS_PLACEHOLDER)}
      previousContent={
        <DemographicInsightsGrid
          title=""
          rows={genderRows}
          getRowLabel={(row) => getGenderRowLabel({ gender: row?.gender, t })}
          getCostByMainCurrency={getCostByMainCurrency}
          sx={{ mt: 1 }}
        />
      }
      sx={sx}
    />
  );
};

export default MetaGenderDemographicInsightsCard;
